/**
 * Google Analytics 4 (GA4) tracking helpers.
 * Measurement ID: G-TEW9BV78EC (configured in public/index.html).
 *
 * All helpers safely no-op if gtag isn't loaded yet (offline/ad-blocker).
 */

const GA_MEASUREMENT_ID = 'G-TEW9BV78EC';

const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

/** Track an SPA page view manually (we disabled auto send_page_view in index.html). */
export const trackPageView = (path, title) => {
  if (!hasGtag()) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
    send_to: GA_MEASUREMENT_ID,
  });
};

/** Generic event tracker. */
export const trackEvent = (eventName, params = {}) => {
  if (!hasGtag()) return;
  window.gtag('event', eventName, {
    ...params,
    send_to: GA_MEASUREMENT_ID,
  });
};

// Domain-specific helpers
export const trackPackageView = (pkg) => {
  trackEvent('view_item', {
    item_id: pkg.id,
    item_name: pkg.name,
    item_category: pkg.category,
    price: pkg.price,
    currency: 'INR',
  });
};

export const trackBookNowClicked = (pkg) => {
  trackEvent('select_item', {
    item_id: pkg.id,
    item_name: pkg.name,
    price: pkg.price,
    currency: 'INR',
  });
};

export const trackBookingSubmitted = (booking, amountINR) => {
  trackEvent('begin_checkout', {
    value: amountINR,
    currency: 'INR',
    items: [
      {
        item_id: booking.package_id,
        item_name: booking.package_name,
        quantity: booking.guests || 1,
        price: amountINR / (booking.guests || 1),
      },
    ],
  });
};

export const trackPaymentInitiated = (method, amount, currency) => {
  trackEvent('add_payment_info', {
    payment_type: method,
    value: amount,
    currency: currency,
  });
};

export const trackPaymentSuccess = (booking, amount, currency, transactionId) => {
  trackEvent('purchase', {
    transaction_id: transactionId || booking.id,
    value: amount,
    currency: currency,
    items: [
      {
        item_id: booking.package_id,
        item_name: booking.package_name,
        quantity: booking.guests || 1,
      },
    ],
  });
};

export const trackContactSubmit = () => {
  trackEvent('generate_lead', { method: 'contact_form' });
};

export const trackWhatsAppClick = () => {
  trackEvent('contact_whatsapp');
};
